/* eslint-disable import/no-extraneous-dependencies, @typescript-eslint/no-unsafe-return */
import produce from 'immer';
import { FormAction, FormActionTypes } from './formActions';

export interface FormState {
  formData : any,
  isLoading: boolean,
  isSuccess: boolean,
  isFailure: boolean,
  isValidRemId: boolean,
}

export const initialState: FormState = {
  formData: {
    remediationId: '',
    remediationIdIsValid: null,
    lastName: '',
    lastNameIsValid: null,
    dobIsValid: true,
    dob: '',
    accountName: '',
    accountNameIsValid: null,
    bsb: '',
    bsbIsValid: null,
    accountNumber: '',
    accountNumberIsValid: null,
    isConsent: null,
  },
  isLoading: false,
  isSuccess: false,
  isValidRemId: true,
  isFailure: false,
};

export const formReducer = produce(
  (state: FormState = initialState, action: any) => {
    switch (action.type) {
    case FormActionTypes.Updated:
      return {
        ...state,
        formData: action.payload,
      };
    case FormActionTypes.Loading:
      return {
        ...state,
        isLoading: true,
      };
    case FormActionTypes.Loaded:
      return {
        ...state,
        isLoading: false,
      };
    case FormActionTypes.Submited:
      return {
        ...state,
      };
    case FormActionTypes.InvalidRemID:
      return {
        ...state,
        isValidRemId: false,
      };
    case FormActionTypes.ValidRemID:
      return {
        ...state,
        isValidRemId: true,
      };
    case FormActionTypes.LoadSuccess:
      return {
        ...state,
        isSuccess: true,
      };
    case FormActionTypes.LoadFailure:
      return {
        ...state,
        isFailure: true,
      };
    default:
      return state;
    }
  },
);

export const getFormLoading = (state: FormState) => state.isLoading;
